/**
 * @file FooterDecorGroup.tsx
 * @description Группа «Рисунок подвала» вкладки «Подвал» (phase19.16 Р1;
 * SB21; SB122 §4.1 — отдельной группой, не внутри нижней полосы): показывать
 * рисунок, файл из медиатеки, «Скрыть на телефоне». Рисунка нет — группа не
 * прячется, а говорит, что подвал без рисунка.
 */

import type { SiteTheme } from "@chaiberi/shared";

import { FieldHint, SettingsGroup } from "../../ui/settings-groups";
import { CheckRow } from "../CheckRow";
import { MediaField } from "../media/MediaField";
import type { SiteBrandDraft, SiteMedia } from "../../../lib/site-view/types";

type Footer = SiteTheme["footer"];

interface Props {
  footer: Footer;
  brand: SiteBrandDraft;
  onChange: (patch: Partial<Footer>) => void;
  onDecor: (media: SiteMedia | null) => void;
}

/** Сводка: «есть · ПК и телефон» / «есть · ПК» / «выключен» / «нет». */
function decorSummary(footer: Footer, brand: SiteBrandDraft): string {
  if (brand.footerDecor === null) return "нет";
  if (!footer.show.decor) return "выключен";
  return footer.decorHideOnMobile ? "есть · ПК" : "есть · ПК и телефон";
}

export function FooterDecorGroup({ footer, brand, onChange, onDecor }: Props) {
  const empty = brand.footerDecor === null;
  return (
    <SettingsGroup id="decor" title="Рисунок подвала" tocLabel="Рисунок" hint="Картинка-украшение в подвале." summary={decorSummary(footer, brand)}>
      {empty ? <FieldHint className="mt-0">Рисунок не выбран — подвал без рисунка.</FieldHint> : null}
      <CheckRow checked={footer.show.decor && !empty} disabled={empty} onChange={(decor) => onChange({ show: { ...footer.show, decor } })}>
        Показывать рисунок подвала
      </CheckRow>
      <MediaField label="Файл рисунка" value={brand.footerDecor} onChange={onDecor} hint="PNG или WebP с прозрачным фоном." />
      <CheckRow checked={footer.decorHideOnMobile} onChange={(decorHideOnMobile) => onChange({ decorHideOnMobile })}>
        Скрыть рисунок на телефоне
      </CheckRow>
    </SettingsGroup>
  );
}
